<div class="no-results">
  <div class="no-results__main">
    <h2 class="no-results__title">
      {{ 'noResults.title' | i18n }}
    </h2>

    <p class="no-results__description">
      {{ 'noResults.text' | i18n }}
    </p>

    <div class="no-results__button">
      <app-search-subscription-button
        class="mobile-full-width"
        origin="results-overview"
      ></app-search-subscription-button>
    </div>
  </div>

  <div class="no-results__map-toggle">
    <app-desktop-map-toggle></app-desktop-map-toggle>
  </div>
</div>
